import * as React from "react";
import { ProjectRevision } from "../models/ProjectRevision";
import { ProtectiveRevision } from "../models/ProtectiveRevision";
import { formatDate } from "../helpers";

interface Props {
  projectRevision: ProjectRevision;
  protectiveRevision: ProtectiveRevision;
}

const RevisionTable = (props: Props) => {
  return (
    <table className="table table-condensed">
      <tbody>
        <tr>
          <th>Project Rev No</th>
          <td>{props.projectRevision.projectVersion}</td>
          <th>Function Executed by/Date</th>
          <td>{props.protectiveRevision.peferBy}</td>
          <th>On</th>
          <td>{formatDate(props.protectiveRevision.peferByDate)}</td>
        </tr>
        <tr>
          <th>Function Rev No</th>
          <td>{props.protectiveRevision.protectiveVersion}</td>
          <th>Function Approved by/Date</th>
          <td>{props.protectiveRevision.approveBy}</td>
          <th>On</th>
          <td>{formatDate(props.protectiveRevision.approveByDate)}</td>
        </tr>
      </tbody>
    </table>
  );
}

export default RevisionTable;
